module.exports = __webpack_public_path__ + "media/images/icons/home-831db11df61127740a8d5f67fb8952cb.svg";